import React from 'react';
import { Text } from '@/components/ui/text/Text';
import { TABLE_PALETTE } from './Table.constants';


export interface ExpandedRowTableColumn {
  key: string;
  label: string;
}

export interface ExpandedRowTableProps {
  columns: ExpandedRowTableColumn[];
  rows: Record<string, string>[];
  emptyMessage?: string;
  columnWidths?: string[];
}

export const ExpandedRowTable: React.FC<ExpandedRowTableProps> = ({
  columns,
  rows,
  emptyMessage,
  columnWidths,
}) => {
  if (rows.length === 0) {
    return (
      <div className="px-4 py-3">
        <Text variant="small-medium">{emptyMessage ?? '-'}</Text>
      </div>
    );
  }

  return (
    <div className="px-4 py-3">
      <table className="w-full text-sm table-fixed">
        {columnWidths && (
          <colgroup>
            {columnWidths.map((width, index) => (
              <col key={index} className={width} />
            ))}
          </colgroup>
        )}
        <thead>
          <tr className="text-left border-b border-gray-200">
            {columns.map((column) => (
              <th key={column.key} scope="col" className="pb-2 pr-8 font-medium">
                <Text variant="small-medium" color={TABLE_PALETTE.headerText}>
                  {column.label}
                </Text>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex} className="border-b border-gray-100 last:border-0">
              {columns.map((column) => (
                <td key={column.key} className="py-2 pr-8">
                  <Text variant="small-medium">{row[column.key] ?? '-'}</Text>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
